import BottomNav from 'components/Header/BottomNav/BottomNav';
import withBottomNavProps from 'viewModel/header/bottomNav/withBottomNavProps';

export default withBottomNavProps(BottomNav);
